module.exports = new __parcel__URL__("step-two.cd055733.svg").toString();